import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import ActivityType from '@alltrails/shared/types/activityType';
import { reviewsApi } from './reviewsApi';

export type ReviewEntityType = 'reviews' | 'photosOnly';

export type ReviewsFacets = {
  query?: string;
  ratings: number[];
  activities: ActivityType[];
  months: number[];
  entityType: ReviewEntityType;
};

export type ReviewsSearchFiltersState = {
  interstitial: ReviewsFacets;
  permanent: ReviewsFacets;
};

const initialFacets: ReviewsFacets = {
  ratings: [],
  activities: [],
  months: [],
  entityType: 'reviews'
};

export const initialState: ReviewsSearchFiltersState = {
  interstitial: initialFacets,
  permanent: initialFacets
};

export const reviewsSearchFiltersSlice = createSlice({
  name: 'reviewsSearchFilter',
  initialState,
  reducers: {
    setInterstitialQuery: (state, action: PayloadAction<string | undefined>) => {
      state.interstitial.query = action.payload;
    },
    setInterstitialEntityType: (state, action: PayloadAction<ReviewEntityType>) => {
      state.interstitial.entityType = action.payload;
    },
    setInterstitialRatings: (state, action: PayloadAction<number[]>) => {
      state.interstitial.ratings = action.payload;
    },
    setInterstitialActivities: (state, action: PayloadAction<ActivityType[]>) => {
      state.interstitial.activities = action.payload;
    },
    setInterstitialMonths: (state, action: PayloadAction<number[]>) => {
      state.interstitial.months = action.payload;
    },
    clearInterstitialFilters: state => {
      state.interstitial = { ...initialFacets, query: state.interstitial.query };
    },
    resetInterstitial: state => {
      state.interstitial = { ...state.permanent };
    },
    saveInterstitial: state => {
      state.permanent = { ...state.interstitial, query: state.interstitial.query?.trim() };
    },
    clearFilters: state => {
      state.permanent = { ...initialFacets, query: state.permanent.query };
      state.interstitial = { ...initialFacets, query: state.interstitial.query };
    },
    clearQuery: state => {
      state.permanent.query = undefined;
      state.interstitial.query = undefined;
    }
  },
  extraReducers: builder => {
    builder.addMatcher(reviewsApi.endpoints.createReview.matchFulfilled, state => {
      state.permanent = { ...initialFacets };
      state.interstitial = { ...initialFacets };
    });
  }
});

export const {
  setInterstitialQuery,
  setInterstitialEntityType,
  setInterstitialRatings,
  setInterstitialActivities,
  setInterstitialMonths,
  clearInterstitialFilters,
  resetInterstitial,
  saveInterstitial,
  clearFilters,
  clearQuery
} = reviewsSearchFiltersSlice.actions;
export default reviewsSearchFiltersSlice.reducer;
